import { useEntity } from 'utils/hooks/api';

/** The parent the score card compares this category against. */
const useParentCategory = (page) =>
    useEntity({ id: page.parentId, dataSource: page.dataSource }).data;

export default useParentCategory;
